// extracted by mini-css-extract-plugin
export default {"playground":"Playground_playground__WLKcw","tilesContainer":"Playground_tilesContainer__orOaZ","tilesList":"Playground_tilesList__W8dDC"};